import { Button, Col, Form, notification, Switch, Row } from "antd"
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../../../app/store"
import { EditableList } from "../../../../../compnents/list/EditableList"
import { getFieldSettingList, saveFieldSettingList } from "../FieldSettingSlice"
import { unwrapResult } from "@reduxjs/toolkit"
import { selectEdition, selectTenantCategory } from "../../../../../app/applicationSlice"
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import {
  DndContext,
  DragEndEvent,
  PointerSensor,
  useSensor,
  useSensors,
  useDndContext,
} from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { CSS } from '@dnd-kit/utilities'
import { selectSettings } from "../../../../user/setting/settingSlice"
import { Checks as SettingChecks } from '../../../../../models/setting'
const BLFeildMap = {
  'TYBL': [
    { key: 'chiefComplaint', label: '主诉', isRequired: false, isVisible: true, rid: 'chiefComplaint', isShowMedicalRecord: false },
    { key: 'historyOfPresentIllness', label: '现病史', isRequired: false, isVisible: true, rid: 'historyOfPresentIllness', isShowMedicalRecord: true },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, isVisible: true, rid: 'pastMedicalHistory', isShowMedicalRecord: true },
    { key: 'lxbsContent', label: '流行病学史', isRequired: false, isVisible: false, rid: 'lxbsContent', isShowMedicalRecord: false },
    { key: 'allergen', label: '过敏史', isRequired: false, isVisible: true, rid: 'allergen', isShowMedicalRecord: true },
    { key: 'personalHistory', label: '个人史', isRequired: false, isVisible: true, rid: 'personalHistory', isShowMedicalRecord: true },
    { key: 'familyHistory', label: '家族史', isRequired: false, isVisible: true, rid: 'familyHistory', isShowMedicalRecord: true },
    { key: 'vaccineHistory', label: '疫苗接种史', isRequired: false, isVisible: true, rid: 'vaccineHistory', isShowMedicalRecord: true },
    { key: 'menstrualHistory', label: '月经史', isRequired: false, isVisible: true, rid: 'menstrualHistory', isShowMedicalRecord: true },
    { key: 'maritalHistory', label: '婚育史', isRequired: false, isVisible: true, rid: 'maritalHistory', isShowMedicalRecord: true },
    { key: 'tgjc', label: '体格检查', isRequired: false, isVisible: true, rid: 'tgjc', isShowMedicalRecord: false },
    { key: 'eyeExamination', label: '眼科检查', isRequired: false, isVisible: false, rid: 'eyeExamination', isShowMedicalRecord: false },
    { key: 'inspectionCheck', label: '辅助检查', isRequired: false, isVisible: true, rid: 'inspectionCheck', isShowMedicalRecord: false },
    { key: 'disease', label: '疾病名称', isRequired: true, isVisible: true, isNotModified: true, rid: 'disease', isShowMedicalRecord: false },
    { key: 'treatmentConclusion', label: '治疗意见', isRequired: false, isVisible: true, rid: 'treatmentConclusion', isShowMedicalRecord: false },
    { key: 'relatedImages', label: '相关影像', isRequired: false, isVisible: true, rid: 'relatedImages', isShowMedicalRecord: false },
  ]?.map((item, index) => ({ ...item, order: index + 1 })),
  'ZYBL': [
    { key: 'chiefComplaint', label: '主诉', isRequired: false, isVisible: true, rid: 'chiefComplaint', isShowMedicalRecord: false },
    { key: 'historyOfPresentIllness', label: '现病史', isRequired: false, isVisible: true, rid: 'historyOfPresentIllness', isShowMedicalRecord: true },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, isVisible: true, rid: 'pastMedicalHistory', isShowMedicalRecord: true },
    { key: 'lxbsContent', label: '流行病学史', isRequired: false, isVisible: false, rid: 'lxbsContent', isShowMedicalRecord: false },
    { key: 'allergen', label: '过敏史', isRequired: false, isVisible: true, rid: 'allergen', isShowMedicalRecord: true },
    { key: 'personalHistory', label: '个人史', isRequired: false, isVisible: true, rid: 'personalHistory', isShowMedicalRecord: true },
    { key: 'familyHistory', label: '家族史', isRequired: false, isVisible: true, rid: 'familyHistory', isShowMedicalRecord: true },
    { key: 'vaccineHistory', label: '疫苗接种史', isRequired: false, isVisible: true, rid: 'vaccineHistory', isShowMedicalRecord: true },
    { key: 'menstrualHistory', label: '月经史', isRequired: false, isVisible: true, rid: 'menstrualHistory', isShowMedicalRecord: true },
    { key: 'maritalHistory', label: '婚育史', isRequired: false, isVisible: true, rid: 'maritalHistory', isShowMedicalRecord: true },
    { key: 'tonguePicture', label: '望诊', isRequired: false, isVisible: true, rid: 'tonguePicture', isShowMedicalRecord: false },
    { key: 'listeningSmelling', label: '闻诊', isRequired: false, isVisible: true, rid: 'listeningSmelling', isShowMedicalRecord: false },
    { key: 'inquiry', label: '问诊', isRequired: false, isVisible: true, rid: 'inquiry', isShowMedicalRecord: false },
    { key: 'pulseCondition', label: '切诊', isRequired: false, isVisible: true, rid: 'pulseCondition', isShowMedicalRecord: false },
    { key: 'tgjc', label: '体格检查', isRequired: false, isVisible: true, rid: 'tgjc', isShowMedicalRecord: false },
    { key: 'inspectionCheck', label: '辅助检查', isRequired: false, isVisible: true, rid: 'inspectionCheck', isShowMedicalRecord: false },
    { key: 'syndromeDifferentiation', label: '辨证论治', isRequired: false, isVisible: true, rid: 'syndromeDifferentiation', isShowMedicalRecord: false },
    { key: 'disease', label: '中医诊断', isRequired: true, isVisible: true, isNotModified: true, rid: 'disease', isShowMedicalRecord: false },
    { key: 'therapeuticPrinciple', label: '治则治法', isRequired: false, isVisible: true, rid: 'therapeuticPrinciple', isShowMedicalRecord: false },
    { key: 'treatmentConclusion', label: '治疗意见', isRequired: false, isVisible: true, rid: 'treatmentConclusion', isShowMedicalRecord: false },
    { key: 'relatedImages', label: '相关影像', isRequired: false, isVisible: true, rid: 'relatedImages', isShowMedicalRecord: false },
  ]?.map((item, index) => ({ ...item, order: index + 1 })),
  'KQBL': [
    { key: 'chiefComplaint', label: '主诉', isRequired: false, isVisible: true, rid: 'chiefComplaint', isShowMedicalRecord: false },
    { key: 'historyOfPresentIllness', label: '现病史', isRequired: false, isVisible: true, rid: 'historyOfPresentIllness', isShowMedicalRecord: true },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, isVisible: true, rid: 'pastMedicalHistory', isShowMedicalRecord: true },
    { key: 'lxbsContent', label: '流行病学史', isRequired: false, isVisible: false, rid: 'lxbsContent', isShowMedicalRecord: false },
    { key: 'allergen', label: '过敏史', isRequired: false, isVisible: true, rid: 'allergen', isShowMedicalRecord: true },
    { key: 'personalHistory', label: '个人史', isRequired: false, isVisible: true, rid: 'personalHistory', isShowMedicalRecord: true },
    { key: 'familyHistory', label: '家族史', isRequired: false, isVisible: true, rid: 'familyHistory', isShowMedicalRecord: true },
    { key: 'vaccineHistory', label: '疫苗接种史', isRequired: false, isVisible: true, rid: 'vaccineHistory', isShowMedicalRecord: true },
    { key: 'menstrualHistory', label: '月经史', isRequired: false, isVisible: true, rid: 'menstrualHistory', isShowMedicalRecord: true },
    { key: 'maritalHistory', label: '婚育史', isRequired: false, isVisible: true, rid: 'maritalHistory', isShowMedicalRecord: true },
    { key: 'tgjc', label: '体格检查', isRequired: false, isVisible: true, rid: 'tgjc', isShowMedicalRecord: false },
    { key: 'stomatologyTooth', label: '口腔检查', isRequired: false, isVisible: true, rid: 'stomatologyTooth', isShowMedicalRecord: false },
    { key: 'inspectionTooth', label: '辅助检查', isRequired: false, isVisible: true, rid: 'inspectionTooth', isShowMedicalRecord: false },
    { key: 'relatedImages', label: '相关影像', isRequired: false, isVisible: true, rid: 'relatedImages', isShowMedicalRecord: false },
    { key: 'diseaseTooth', label: '口腔诊断', isRequired: true, isVisible: true, rid: 'diseaseTooth', isShowMedicalRecord: false },
    { key: 'treatmentTooth', label: '治疗计划', isRequired: false, isVisible: true, rid: 'treatmentTooth', isShowMedicalRecord: false },
    { key: 'disposeTooth', label: '处置', isRequired: false, isVisible: true, rid: 'disposeTooth', isShowMedicalRecord: false },
    { key: 'treatmentConclusion', label: '治疗意见', isRequired: false, isVisible: true, rid: 'treatmentConclusion', isShowMedicalRecord: false },
  ]?.map((item, index) => ({ ...item, order: index + 1 })),
  'MRBL': [
    { key: 'chiefComplaint', label: '主诉', isRequired: false, isVisible: true, rid: 'chiefComplaint', isShowMedicalRecord: false },
    { key: 'historyOfPresentIllness', label: '现病史', isRequired: false, isVisible: true, rid: 'historyOfPresentIllness', isShowMedicalRecord: true },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, isVisible: true, rid: 'pastMedicalHistory', isShowMedicalRecord: true },
    { key: 'lxbsContent', label: '流行病学史', isRequired: false, isVisible: false, rid: 'lxbsContent', isShowMedicalRecord: false },
    { key: 'allergen', label: '过敏史', isRequired: false, isVisible: true, rid: 'allergen', isShowMedicalRecord: true },
    { key: 'personalHistory', label: '个人史', isRequired: false, isVisible: true, rid: 'personalHistory', isShowMedicalRecord: true },
    { key: 'familyHistory', label: '家族史', isRequired: false, isVisible: true, rid: 'familyHistory', isShowMedicalRecord: true },
    { key: 'vaccineHistory', label: '疫苗接种史', isRequired: false, isVisible: true, rid: 'vaccineHistory', isShowMedicalRecord: true },
    { key: 'menstrualHistory', label: '月经史', isRequired: false, isVisible: true, rid: 'menstrualHistory', isShowMedicalRecord: true },
    { key: 'maritalHistory', label: '婚育史', isRequired: false, isVisible: true, rid: 'maritalHistory', isShowMedicalRecord: true },
    { key: 'tgjc', label: '体格检查', isRequired: false, isVisible: true, rid: 'tgjc', isShowMedicalRecord: false },
    { key: 'inspectionCheck', label: '辅助检查', isRequired: false, isVisible: true, rid: 'inspectionCheck', isShowMedicalRecord: false },
    { key: 'disease', label: '中医诊断', isRequired: true, isVisible: true, rid: 'disease', isShowMedicalRecord: false },
    { key: 'treatmentConclusion', label: '治疗意见', isRequired: false, isVisible: true, rid: 'treatmentConclusion', isShowMedicalRecord: false },
    { key: 'relatedImages', label: '相关影像', isRequired: false, isVisible: true, rid: 'relatedImages', isShowMedicalRecord: false },
  ]?.map((item, index) => ({ ...item, order: index + 1 })),
}

const splitMedicalHistoryKeys = ['personalHistory', 'familyHistory', 'vaccineHistory', 'menstrualHistory', 'maritalHistory']

console.log('splitMedicalHistoryKeys', BLFeildMap)

// 兼容旧的 medicalHistory 合并字段，并补齐新增默认字段
const mergeDefaultFields = (backendFields: any[] = [], defaultFields: any[] = []) => {
  const defaultKeys = defaultFields.map((field: any) => field.key)
  const legacyMedicalHistory = backendFields.find((field: any) => field.key === 'medicalHistory')
  const backendFieldMap = backendFields.reduce((map: any, field: any) => {
    if (field.key !== 'medicalHistory') {
      map[field.key] = field
    }
    return map
  }, {})

  const mergedFields = defaultFields.map((defaultField: any, index: number) => {
    const backendField = backendFieldMap[defaultField.key]
    const inheritedField = !backendField && splitMedicalHistoryKeys.includes(defaultField.key) ? legacyMedicalHistory : undefined
    const field = backendField || inheritedField || {}

    // 辨证论治没数据时，强制排在中医诊断(disease)之前
    let order = field.order || defaultField.order || index + 1
    if (defaultField.key === 'syndromeDifferentiation' && !backendField) {
      const diseaseField = backendFieldMap['disease']
      const diseaseDefault = defaultFields.find((f: any) => f.key === 'disease')
      const diseaseOrder = diseaseField?.order ?? diseaseDefault?.order ?? (index + 2)
      order = Math.max(1, diseaseOrder - 1)
    }

    return {
      ...defaultField,
      ...field,
      key: defaultField.key,
      label: defaultField.label,
      rid: defaultField.key,
      isNotModified: defaultField.isNotModified || false,
      isRequired: field.isRequired === undefined ? defaultField.isRequired : Boolean(field.isRequired),
      isVisible: field.isVisible === undefined ? defaultField.isVisible : Boolean(field.isVisible),
      order,
    }
  })
  const otherBackendFields = backendFields
    .filter((field: any) => field.key !== 'medicalHistory' && !defaultKeys.includes(field.key))
    .map((field: any) => ({
      ...field,
      rid: field.key,
      isRequired: Boolean(field.isRequired),
      isVisible: Boolean(field.isVisible),
      order: field.order || 1,
    }))

  return [...mergedFields, ...otherBackendFields].sort((a: any, b: any) => a.order - b.order).map((field: any, index: number) => ({
    ...field,
    order: index + 1,
  }))
}

export const MedicalRecordSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const [form] = Form.useForm()

  const hisVersion = useSelector(selectEdition)

  const settings = useSelector(selectSettings)

  const [buttonLoading, setButtonLoading] = useState(false)

  const [tableLoading, setTableLoading] = useState(false)

  const [selectedType, setSelectedType] = useState<string>(hisVersion == 1 ? 'KQBL' : 'TYBL')

  const [params, setParams] = useState<any>({
    functionType: 1,
    templateType: selectedType,
  })
  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })
  const tenantCategory = useSelector(selectTenantCategory)

  // 需要作为整体拖拽的病史相关字段组
  const MEDICAL_HISTORY_GROUP = ['personalHistory', 'familyHistory', 'vaccineHistory', 'menstrualHistory', 'maritalHistory']

  // 修复：重构拖拽行组件，确保透传所有属性
  const SortableRow = (props: any) => {
    const { active } = useDndContext()
    const currentKey = props.record?.key
    // 当前行属于病史组，且正在拖拽的也是病史组内字段
    const isInActiveGroup = active
      && MEDICAL_HISTORY_GROUP.includes(currentKey)
      && MEDICAL_HISTORY_GROUP.includes(active.id as string)

    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props['data-row-key'], // 绑定行的唯一ID（rid）
      data: {
        type: 'row',
        item: props.record, // 透传当前行数据
      },
    })

    const highlighted = isDragging || isInActiveGroup

    // 拖拽时的样式优化
    const style: React.CSSProperties = {
      ...props.style,
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: 'move',
      opacity: highlighted ? 0.8 : 1,
      zIndex: highlighted ? 9999 : 'inherit',
      backgroundColor: highlighted ? '#f5f7fa' : 'inherit',
    }

    return (
      <tr
        {...props}
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        id={props['data-row-key']} // 使用rid作为行ID
      />
    )
  }

  // 修复：拖拽传感器配置（增加激活延迟，避免误触）
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5, // 拖动5px才触发，减少误触
      },
    }),
  )

  // 修复：拖拽结束逻辑，支持病史五字段整体拖拽
  const onDragEnd = (event: DragEndEvent) => {
    const { active, over } = event
    if (!active || !over || active.id === over.id) return

    const items = page.items
    const activeIndex = items.findIndex((item: any) => item.rid === active.id)
    const overIndex = items.findIndex((item: any) => item.rid === over.id)

    if (activeIndex === -1 || overIndex === -1) return

    const activeItem = items[activeIndex]
    const overItem = items[overIndex]
    const isActiveGrouped = MEDICAL_HISTORY_GROUP.includes(activeItem.key)
    const isOverGrouped = MEDICAL_HISTORY_GROUP.includes(overItem.key)

    let newItems: any[]

    if (isActiveGrouped) {
      // 拖拽的是病史组内字段：找到组的起止索引
      const groupStart = items.findIndex((item: any) => MEDICAL_HISTORY_GROUP.includes(item.key))
      const groupEnd = items.map((item: any, i: number) => MEDICAL_HISTORY_GROUP.includes(item.key) ? i : -1)
        .filter((i: number) => i !== -1)
        .pop()!

      // 拖到组内部，不处理
      if (overIndex >= groupStart && overIndex <= groupEnd) return

      const groupItems = items.slice(groupStart, groupEnd + 1)

      // 移除整组
      const withoutGroup = [
        ...items.slice(0, groupStart),
        ...items.slice(groupEnd + 1),
      ]

      // 计算插入位置（移除组后索引会偏移）
      const insertIndex = overIndex > groupEnd
        ? overIndex - groupItems.length + 1
        : overIndex

      newItems = [
        ...withoutGroup.slice(0, insertIndex),
        ...groupItems,
        ...withoutGroup.slice(insertIndex),
      ]
    } else if (isOverGrouped) {
      // 拖拽非组内字段到组内位置：插入到组之前
      const groupStart = items.findIndex((item: any) => MEDICAL_HISTORY_GROUP.includes(item.key))
      const targetIdx = activeIndex < groupStart ? groupStart - 1 : groupStart
      newItems = arrayMove([...items], activeIndex, Math.max(0, targetIdx))
    } else {
      // 普通拖拽
      newItems = arrayMove([...items], activeIndex, overIndex)
    }

    const updatedItems = newItems.map((item, index) => ({
      ...item,
      order: index + 1,
    }))

    setPage((prev: any) => ({
      ...prev,
      items: updatedItems,
    }))

    // 拖拽结束后闪烁高亮：病史组五行都闪，普通字段只闪拖拽行
    requestAnimationFrame(() => {
      if (isActiveGrouped) {
        MEDICAL_HISTORY_GROUP.forEach((key) => {
          const el = document.getElementById(key)
          if (el) {
            el.classList.add('drag-flash')
            setTimeout(() => el.classList.remove('drag-flash'), 500)
          }
        })
      } else {
        const el = document.getElementById(active.id as string)
        if (el) {
          el.classList.add('drag-flash')
          setTimeout(() => el.classList.remove('drag-flash'), 500)
        }
      }
    })
  }

  useEffect(() => {
    if (props?.selectedTab !== 'A1') return
    getPage(selectedType)
  }, [props?.selectedTab])

  const getPage = (templateType: string) => {
    setTableLoading(true)
    dispatch(getFieldSettingList({
      functionType: 1,
      templateType: templateType || selectedType,
    }))
      .then(unwrapResult)
      .then((res) => {
        if (res.length === 0) {
          const feilds = BLFeildMap[templateType as keyof typeof BLFeildMap]
          setPage({
            total: feilds.length,
            items: feilds,
          })
          setTableLoading(false)
          return
        } else {
          // 从后端获取的字段数据
          const backendFields = res[0].fields

          // 获取默认字段定义，用于合并 isNotModified 属性
          const defaultFields = BLFeildMap[templateType as keyof typeof BLFeildMap]

          // 合并默认字段的属性，补充rid（关键：拖拽需要唯一ID），并兼容旧的病史合并字段
          const mergedFields = mergeDefaultFields(backendFields, defaultFields)
          setPage({
            total: mergedFields?.length,
            items: mergedFields,
          })
          setTableLoading(false)
        }
      })
      .catch((err) => {
        setTableLoading(false)
      })
  }

  return (
    <div style={{ height: '100%' }}>
      <div style={{ padding: '0 4px', flexShrink: 0 }}>
        {hisVersion == 1 ? <></> :
          <>
            <Button
              type={selectedType === 'TYBL' ? 'primary' : 'default'}
              onClick={() => {
                setSelectedType('TYBL')
                getPage('TYBL')
              }}
              style={{ marginRight: '8px' }}
            >
              通用病历
            </Button>
            <Button
              type={selectedType === (tenantCategory == 16 ? 'MRBL' : 'ZYBL') ? 'primary' : 'default'}
              onClick={() => {
                setSelectedType(tenantCategory == 16 ? 'MRBL' : 'ZYBL')
                getPage(tenantCategory == 16 ? 'MRBL' : 'ZYBL')
              }}
              style={{ marginRight: '8px' }}
            >
              {tenantCategory == 16 ? '盲人病历' : '中医病历'}
            </Button>
            <Button
              type={selectedType === 'KQBL' ? 'primary' : 'default'}
              onClick={() => {
                setSelectedType('KQBL')
                getPage('KQBL')
              }}
            >
              口腔病历
            </Button>
          </>}
      </div>
      <div style={{ margin: '10px 0 6px 0' }}>注：列表支持上下拖动调整字段顺序</div>
      <div style={{
        height: 'calc(100% - 80px)',
        borderRadius: '8px',
      }}>
        <Form
          style={{ height: '100%' }}
          form={form}
          autoComplete='off'
          onFinish={() => {
            setButtonLoading(true)
            dispatch(
              saveFieldSettingList({
                configType: 1,
                functionType: 1,
                templateType: selectedType,
                fields: page.items,
              })
            )
              .then(unwrapResult)
              .then((val) => {
                notification.success({
                  message: '设置成功',
                })
                form.resetFields()
                getPage(selectedType)
              })
              .finally(() => {
                setButtonLoading(false)
              })
          }}
        >
          <div style={{ height: hisVersion == 1 ? 'calc(100% - 28px)' : 'calc(100% - 50px)', paddingBottom: '20px', overflowY: 'auto' }}>
            <Row>
              <Col span={18}>
                <style>{`
                   .drag-flash,
                    .drag-flash td {
                      background-color: rgb(255, 248, 220) !important;
                    }
                 `}</style>
                {/* 修复：DndContext的onDragEnd直接绑定，无需透传参数 */}
                <DndContext
                  sensors={sensors}
                  modifiers={[restrictToVerticalAxis]}
                  onDragEnd={onDragEnd}
                >
                  {/* 修复：SortableContext的items使用page.items的rid数组 */}
                  <SortableContext
                    items={page.items.map((i: any) => i.rid)}
                    strategy={verticalListSortingStrategy}
                  >
                    <EditableList
                      components={{
                        body: {
                          row: SortableRow, // 使用修复后的拖拽行组件
                        },
                      }}
                      loading={tableLoading}
                      rowKey={(record: any) => record.rid} // 确保rowKey和拖拽ID一致
                      dataSource={page.items} // 替换page属性为标准dataSource（适配antd Table）
                      bordered={true}
                      pagination={false}
                      columns={[
                        {
                          title: '序号',
                          key: 'no',
                          align: 'center',
                          width: '5rem',
                          render: (_1, _2, i) => `${i + 1}`,
                        },
                        {
                          title: '病历字段',
                          dataIndex: "label",
                          key: "label",
                          align: "left",
                          width: '24rem',
                        },
                        {
                          title: '是否必填',
                          dataIndex: "isRequired",
                          key: "isRequired",
                          align: "center",
                          width: '12rem',
                          render: function action(_, t, index) {
                            return (
                              <Switch
                                checkedChildren='开启'
                                unCheckedChildren='关闭'
                                checked={t.isRequired}
                                disabled={settings?.[SettingChecks.DZBLCTSD] && selectedType === 'TYBL' ? true : t.isNotModified} // 如果isNotModified为true，则禁用开关
                                onChange={(checked) => {
                                  // 如果isNotModified为true，则不允许修改
                                  if (t.isNotModified) {
                                    return
                                  }
                                  const newItems = [...page.items]
                                  // 如果开启必填项，则自动开启展示项
                                  const newIsVisible = checked ? true : t.isVisible
                                  newItems[index] = {
                                    ...newItems[index],
                                    isRequired: checked,
                                    isVisible: newIsVisible
                                  }
                                  setPage({ ...page, items: newItems })
                                }}
                              />
                            )
                          },
                        },
                        {
                          title: '是否展示',
                          key: 'isVisible',
                          dataIndex: "isVisible",
                          align: 'center',
                          width: '12rem',
                          render: function action(_, t, index) {
                            return (
                              <Switch
                                checkedChildren='开启'
                                unCheckedChildren='关闭'
                                checked={t.isVisible}
                                disabled={settings?.[SettingChecks.DZBLCTSD] && selectedType === 'TYBL' ? true : t.isRequired || t.isNotModified} // 当必填项开启或isNotModified为true时禁用展示项
                                onChange={(checked) => {
                                  // 如果必填项已开启或isNotModified为true，则不允许修改
                                  if (t.isRequired || t.isNotModified) {
                                    return
                                  }
                                  const newItems = [...page.items]
                                  newItems[index] = { ...newItems[index], isVisible: checked }
                                  setPage({ ...page, items: newItems })
                                }}
                              />
                            )
                          },
                        },
                      ]}
                    />
                  </SortableContext>
                </DndContext>
              </Col>
            </Row>
          </div>
          <Row style={{ paddingTop: '10px' }}>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => getPage(selectedType)}
                style={{ float: 'right', marginRight: '10px' }}
                disabled={settings?.[SettingChecks.DZBLCTSD] && selectedType === 'TYBL' ? true : false}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{ float: 'left' }}
                disabled={settings?.[SettingChecks.DZBLCTSD] && selectedType === 'TYBL' ? true : false}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}
